import {
  UnauthorizedError,
  ForbiddenError,
  APIError,
  AlreadySubmittedError,
} from "../Utils/Errors.tsx";
import { navigate } from "./navigator";
import { getSessionId } from "../analytics/appInsights";
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";

console.log("API_BASE_URL = ", API_BASE_URL);
/**
 * Utility function to make API calls.
 * @param {string} endpoint - API endpoint (e.g., '/attributes')
 * @param {string} method - HTTP method (GET, POST, PUT, DELETE)
 * @param {object} body - Request body (for POST/PUT)
 * @returns {Promise} - Resolves to JSON response
 */

export const fetchFromAPI = async (endpoint, method = "GET", body = null) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      method,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-Session-Id": getSessionId(),
      },
      body: body ? JSON.stringify(body) : null,
    });

    if (!response.ok) {
      if (response.status === 401) {
        navigate("/app/session-expiry");
        throw new UnauthorizedError("Unauthorized access.");
      } else if (response.status === 403) {
        throw new ForbiddenError("Access forbidden.");
      } else if (response.status === 409) {
        navigate("/app/pending-verification");
        throw new AlreadySubmittedError("Application already submitted.");
      } else if (response.status >= 500 || response.status === 404) {
        navigate("/app/something-went-wrong");
        throw new APIError(`Request failed with status ${response.status}.`);
      }
    }

    try {
      // console.log("API End Time = ", new Date().toLocaleTimeString());
      return await response.json();
    } catch (error) {
      return { message: "Success, but no JSON response available" };
    }
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const redirectToRealMe = () => {
  localStorage.clear();
  window.location.href = `${API_BASE_URL}/seamless`;
};
